import { InternalAxiosRequestConfig } from 'axios';
import { useUserStore } from 'src/store/user-store';

export const attachDirectoryTokenLockspace = (
  config: InternalAxiosRequestConfig,
) => {
  if (config.skipTenantAttachment) {
    return config;
  }

  const userDirectoryTokenLockspace =
    useUserStore.getState().directoryTokenLockspace;

  if (userDirectoryTokenLockspace) {
    config.url = `${userDirectoryTokenLockspace}${config.url}`;
  }

  return config;
};
